import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../../../atom/Dropdown/Dropdown";
import { useMemo, useState } from "react";
import clsx from "clsx";
import CalendarVisibilityCheckBox from "../../../../atom/Common/CalendarVisibilityCheckbox";
import { useFetchUserCalendarsQuery } from "../../../../../react-query/userCalendars/queries";
import { useUpdateUserCalendarMutation } from "../../../../../react-query/userCalendars/mutations";
import CalendarDot from "./CalendarDot";

const CalendarFilter = () => {
  const fetchUserCalendarsQuery = useFetchUserCalendarsQuery();
  const updateUserCalendar = useUpdateUserCalendarMutation();

  const [isOpen, setIsOpen] = useState(false);

  const showUserCalendarList = useMemo(
    () => fetchUserCalendarsQuery.data?.filter((calendar) => calendar.show) ?? [],
    [fetchUserCalendarsQuery.data]
  );

  const handleOpenChange = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  const handleToggleCalendarShow = (calendarId: number, checked: boolean) => {
    updateUserCalendar.mutate({
      id: calendarId,
      data: { show: checked },
    });
  };

  if (!fetchUserCalendarsQuery.data) return;

  return (
    <DropdownMenu
      open={isOpen}
      onOpenChange={handleOpenChange}
      modal={false}
    >
      <DropdownMenuTrigger asChild>
        <button
          className={clsx(
            "py-1 px-2 h-8 rounded-[5px] bg-transparent hover:bg-w-8-hover hover:text-white cursor-pointer text-[14px] font-normal text-80 flex items-center gap-1",
            { "bg-w-8-hover text-white": isOpen }
          )}
        >
          Calender
          {showUserCalendarList.length > 0 && (
            <div className="flex -space-x-[5px]">
              {showUserCalendarList
                .filter((_, idx) => idx < 5)
                .map((calendar) => (
                  <CalendarDot
                    key={calendar.id}
                    color={calendar.backgroundColor}
                  />
                ))}
            </div>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        width="300px"
        sideOffset={5}
        align={"end"}
        side={"bottom"}
        className="py-1 pl-2"
        maxHeight={275}
        showScrollbar
        onCloseAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        {fetchUserCalendarsQuery.data.map((calendar) => (
          <DropdownMenuCheckboxItem
            key={calendar.id}
            className="flex h-9 px-[6px] items-center gap-2 self-stretch hover:bg-w-8-hover cursor-pointer rounded-[5px] text-body1 data-[highlighted]:outline-none data-[highlighted]:bg-w-8-hover"
            checked={calendar.show}
            onSelect={(e) => {
              // 체크박스 클릭 시 드롭다운 닫히지 않도록 추가
              e.preventDefault();
            }}
            onCheckedChange={(checked) => {
              handleToggleCalendarShow(calendar.id, checked);
            }}
          >
            <CalendarVisibilityCheckBox
              isSelected={calendar.show}
              baseColor={calendar.backgroundColor}
              size={16}
              checkColor="#1a1c1c"
              borderRadius="5px"
            />
            <p className="text-14px font-normal text-white overflow-hidden text-ellipsis whitespace-nowrap">
              {calendar.name}
            </p>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CalendarFilter;
